import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { TrendingUp, TrendingDown, AlertCircle } from 'lucide-react';
export function StakesSection() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  return <section className="relative py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-black overflow-hidden" data-id="element-4950">
      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 30
    }} animate={inView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto text-center" data-id="element-4951">
        <div className="mb-8 sm:mb-12" data-id="element-4952">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-stone-100 mb-6 sm:mb-8" style={{
          fontFamily: 'Cinzel, serif'
        }} data-id="element-4953">
            The Cost of Inaction
          </h2>
          <p className="text-lg sm:text-xl text-stone-400 max-w-2xl mx-auto" data-id="element-4954">
            Every day you wait is another day your biology is operating below
            its potential.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-12 sm:mb-16" data-id="element-4955">
          <div className="bg-red-950/20 border border-red-900/30 p-6 sm:p-8 rounded-xl" data-id="element-4956">
            <div className="flex justify-center mb-4 sm:mb-6" data-id="element-4957">
              <TrendingDown className="w-10 h-10 sm:w-12 sm:h-12 text-red-500" data-id="element-4958" />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-red-400 mb-3 sm:mb-4" data-id="element-4959">
              Without This Knowledge
            </h3>
            <ul className="space-y-3 sm:space-y-4 text-left text-stone-300 text-sm sm:text-base" data-id="element-4960">
              <li className="flex items-start gap-3" data-id="element-4961">
                <span className="text-red-500 font-bold" data-id="element-4962">✕</span>
                <span data-id="element-4963">Guessing with your health</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-4964">
                <span className="text-red-500 font-bold" data-id="element-4965">✕</span>
                <span data-id="element-4966">Wasting money on ineffective supplements</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-4967">
                <span className="text-red-500 font-bold" data-id="element-4968">✕</span>
                <span data-id="element-4969">Following outdated medical advice</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-4970">
                <span className="text-red-500 font-bold" data-id="element-4971">✕</span>
                <span data-id="element-4972">Continued decline and aging</span>
              </li>
            </ul>
          </div>

          <div className="bg-green-950/20 border border-green-900/30 p-6 sm:p-8 rounded-xl" data-id="element-4973">
            <div className="flex justify-center mb-4 sm:mb-6" data-id="element-4974">
              <TrendingUp className="w-10 h-10 sm:w-12 sm:h-12 text-green-500" data-id="element-4975" />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-green-400 mb-3 sm:mb-4" data-id="element-4976">
              With PSI PRO
            </h3>
            <ul className="space-y-3 sm:space-y-4 text-left text-stone-300 text-sm sm:text-base" data-id="element-4977">
              <li className="flex items-start gap-3" data-id="element-4978">
                <span className="text-green-500 font-bold" data-id="element-4979">✓</span>
                <span data-id="element-4980">Precision control of your biology</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-4981">
                <span className="text-green-500 font-bold" data-id="element-4982">✓</span>
                <span data-id="element-4983">Access to cutting-edge protocols</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-4984">
                <span className="text-green-500 font-bold" data-id="element-4985">✓</span>
                <span data-id="element-4986">Direct guidance from experts</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-4987">
                <span className="text-green-500 font-bold" data-id="element-4988">✓</span>
                <span data-id="element-4989">Regeneration and optimization</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="bg-amber-950/20 border border-amber-500/30 p-6 sm:p-8 rounded-lg mb-10 sm:mb-12" data-id="element-4990">
          <div className="flex items-start gap-4" data-id="element-4991">
            <AlertCircle className="w-6 h-6 sm:w-8 sm:h-8 text-amber-500 flex-shrink-0 mt-1" data-id="element-4992" />
            <div className="text-left" data-id="element-4993">
              <p className="text-lg sm:text-xl font-bold text-amber-400 mb-2" data-id="element-4994">
                Remember:
              </p>
              <p className="text-stone-300 text-base sm:text-lg" data-id="element-4995">
                The PRO membership offer expires soon. This is your only chance
                to lock in this pricing for life.
              </p>
            </div>
          </div>
        </div>

        <button onClick={() => {
        const pricingSection = document.querySelector('[data-pricing-section]');
        if (pricingSection) {
          pricingSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }} className="inline-block px-8 sm:px-12 py-4 sm:py-5 bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-500 hover:to-amber-400 text-black font-bold text-lg sm:text-xl rounded-lg shadow-[0_0_30px_rgba(217,119,6,0.4)] hover:shadow-[0_0_50px_rgba(217,119,6,0.6)] hover:scale-105 transition-all duration-300 min-h-[44px]" data-id="element-4996">
          Join the Private Research Order Now
        </button>
      </motion.div>
    </section>;
}